import { z } from "zod";
import { AS_ON, KPL, MBAPL, SGFL, SIPL } from "./consts";

export const schema = z.object({
  [AS_ON]: z.any(),
  [KPL]: z.string().min(1, "This field is required"),
  [MBAPL]: z.string().min(1, "This field is required"),
  [SGFL]: z.string().min(1, "This field is required"),
  [SIPL]: z.string().min(1, "This field is required"),
});

export type formValues = z.infer<typeof schema>;
